export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function filenameFromHeaders(headers, fallback = "download") {
  const cd = headers?.["content-disposition"] || headers?.["Content-Disposition"];
  if (!cd) return fallback;
  const match = /filename="?([^"]+)"?/i.exec(cd);
  return match?.[1] || fallback;
}
